
export const DocumentFields = {
    // Summary section
    Subject: "DocumentBody.Summary.Subject",
    ServiceGrade: "DocumentBody.Summary.ServiceGrade",
    ProductGroup: "DocumentBody.Summary.ProductGroup",
    ProductSubgroup: "DocumentBody.Summary.ProductSubgroup",
    ServiceRequestNr: "DocumentBody.Summary.ServiceRequestNr",
    OriginalIssueDate: "DocumentBody.Summary.OriginalIssueDate",
    IssueDate: "DocumentBody.Summary.IssueDate",
    ServiceLimitTime: "DocumentBody.Summary.ServiceLimitTime",
    ServicePeriod: "DocumentBody.Summary.ServicePeriod",
    Status: "DocumentBody.Summary.Status",
    PublicMessage: "DocumentBody.Summary.PublicMessage",
    OrganisationalComment: "DocumentBody.Summary.OrganisationalComment",
    ReasonForUpdate: "DocumentBody.Summary.ReasonForUpdate",
    Confidentiality: "DocumentBody.Summary.Confidentiality",
    ServiceRequestNrVersion: "DocumentBody.Summary.ServiceRequestNr.Version",

    // Applied Models section
    AppliedModelMfgNrs: "DocumentBody.Detail.AppliedModelMfgNrs",
    ProductNr: "DocumentBody.Detail.AppliedModelMfgNrs.ProductNr",
    PosCode: "DocumentBody.Detail.AppliedModelMfgNrs.PosCode",
    Material: "DocumentBody.Detail.AppliedModelMfgNrs.Material",
    ModelProductGroup: "DocumentBody.Detail.AppliedModelMfgNrs.ProductGroup",
    ModelProductSubgroup: "DocumentBody.Detail.AppliedModelMfgNrs.ProductSubgroup",
    SerialNrFrom: "DocumentBody.Detail.AppliedModelMfgNrs.SerialNrFrom",
    SerialNrTo: "DocumentBody.Detail.AppliedModelMfgNrs.SerialNrTo",
    SpecificComplementaryCondition: "DocumentBody.Detail.AppliedModelMfgNrs.SpecificComplementaryCondition",
    TotalQuantityOfUnitsInScope: "DocumentBody.Detail.AppliedModelMfgNrs.TotalQuantityOfUnitsInScope",
    Exclusions: "DocumentBody.Detail.Exclusions",

    // Detail of Trouble section
    DetailOfTrouble: "DocumentBody.Detail.DetailOfTrouble",
    Phenomena: "DocumentBody.Detail.DetailOfTrouble.Phenomena",
    EstimatedRatio: "DocumentBody.Detail.DetailOfTrouble.EstimatedRatio",
    Cause: "DocumentBody.Detail.DetailOfTrouble.Cause",

    // Countermeasure section
    Countermeasure: "DocumentBody.Detail.Countermeasure",
    CountermeasureContent: "DocumentBody.Detail.Countermeasure.Content",
    FieldInstalledUnits: "DocumentBody.Detail.Countermeasure.FieldInstalledUnits",
    FieldStockUnits: "DocumentBody.Detail.Countermeasure.FieldStockUnits",
    DENVStockUnits: "DocumentBody.Detail.Countermeasure.DENVStockUnits",
    MassProductionUnits: "DocumentBody.Detail.Countermeasure.MassProductionUnits",
    FieldSparePartsStock: "DocumentBody.Detail.Countermeasure.FieldSparePartsStock",
    DENVSparePartsStock: "DocumentBody.Detail.Countermeasure.DENVSparePartsStock",

    // Service Cost section
    SpareParts: "DocumentBody.Detail.SpareParts",
    ServiceCost: "DocumentBody.Detail.ServiceCost",
    LabourAndExpenses: "DocumentBody.Detail.ServiceCost.LabourAndExpenses",
    ServicePartsCost: "DocumentBody.Detail.ServiceCost.ServicePartsCost",
    CostClaimProcedure: "DocumentBody.Detail.CostClaimProcedure",
    Remark: "DocumentBody.Detail.Remark",
    SVNumbers: "DocumentBody.Detail.SVNumbers",

    // Appendix & Work Instructions
    AppendixAndWorkInstructions: "DocumentBody.Detail.AppendixAndWorkInstructions",
    GroupAttachments: "DocumentBody.Detail.AppendixAndWorkInstructions.GroupAttachments",
    AffiliateAttachmentsByDENV: "DocumentBody.Detail.AppendixAndWorkInstructions.AffiliateAttachmentsByDENV",
    AffiliateAttachmentsByAFF: "DocumentBody.Detail.AppendixAndWorkInstructions.AffiliateAttachmentsByAFF",

    // Approval section
    IssuedBy: "DocumentBody.Detail.IssuedBy",
    CheckedBy: "DocumentBody.Detail.CheckedBy",
    ApprovedBy1: "DocumentBody.Detail.ApprovedBy1",
    ApprovedBy2: "DocumentBody.Detail.ApprovedBy2",

    // Internal Documents section
    ExecutionFollowUp: "ExecutionFollowUp",
    InternalDocuments: "InternalDocuments",
    DistributionSettings: "InternalDocuments.DistributionSettings",
    IssuingPartyOfESV: "InternalDocuments.IssuingPartyOfESV",
    ResponsibleParty: "InternalDocuments.ResponsibleParty",
    ResponsibleOrganisation: "InternalDocuments.ResponsibleOrganisation",
    ClaimReferences: "InternalDocuments.ClaimReferences",
    InternalDocumentsSection: "InternalDocuments.InternalDocuments",
    DistributionTargets: "InternalDocuments.DistributionTargets",
    DistributionSettingsDistributionStep: "InternalDocuments.DistributionSettings.DistributionStep",

    // Situation section
    Situation: "Situation",
    PersonInCharge: "Situation.PersonInCharge",
    Topic: "Situation.Topic",
    TargetDate: "Situation.TargetDate",
    PreparationSteps: "Situation.PreparationSteps",
    DistributionSteps: "Situation.DistributionSteps",

    // Edit Applied Models section
    CheckboxProductNo: "DocumentBody.EditAppliedModelsXModel.CheckboxProductNo",
    CheckboxMaterial: "DocumentBody.EditAppliedModelsXModel.CheckboxMaterial",
    CheckboxSerialFrom: "DocumentBody.EditAppliedModelsXModel.CheckboxSerialFrom",
    CheckboxPOSCode: "DocumentBody.EditAppliedModelsXModel.CheckboxPOSCode",
    CheckboxSerialTo: "DocumentBody.EditAppliedModelsXModel.CheckboxSerialTo",
    Checkboxes: "DocumentBody.EditAppliedModelsXModel.Checkboxes",

    // Input section
    InputCreateVersion: "Input.Create.Version",
    InputCreateServiceGrade: "Input.Create.ServiceGrade",
    InputCreateServiceLimitTime: "Input.Create.ServiceLimitTime",
    InputCreateServicePeriod: "Input.Create.ServicePeriod",
    InputCopyVersionSourceDocument: "Input.Copy.VersionSourceDocument",
    InputCopyVersionTargetDocument: "Input.Copy.VersionTargetDocument",
};
